let listeners: any[] = []

export default {
  registerListener(func: any) {
    listeners.push(func)
  },
  notify: function (severity: string, message: string) {
    for (let i = 0; i < listeners.length; i++) {
      listeners[i](severity, message)
    }

  }
}
